let services = {
    donation: {
        title: 'Donation',
        image: '/images/donation.png',
        description: 'Find generous donors willing to help people in need',
    },

    communityService: {
        title: 'Community Service',
        image: '/images/communityService.png',
        description: 'Would you like to help serve the community?',
    },

    animalAdoption: {
        title: 'Animal Adoption',
        image: '/images/animalAdoption.png',
        description: 'Rescue a pet today!',
    },

    tutoring: {
        title: 'Tutoring',
        image: '/images/tutoring.png',
        description: 'Find people with a passion for tutoring in various subjects',
    },

    exchange: {
        title: 'Exchange',
        image: '/images/exchange.png',
        description: 'Exchange friendly words with people in your community',
    },

    accommodation: {
        title: 'Accommodation',
        image: '/images/accommodation.png',
        description: 'Find out how you can receive accommodations',
    },
}

export default services
